export enum ExtraPriceType {
  INITIAL_CONSULTATION = 'INITIAL_CONSULTATION', // 초진료
  FOLLOW_UP_CONSULTATION = 'FOLLOW_UP_CONSULTATION', // 재진료
  COUNSELING = 'COUNSELING', // 상담료
  SURFACE_ANESTHESIA = 'SURFACE_ANESTHESIA', // 표면 마취비
  LOCAL_ANESTHESIA = 'LOCAL_ANESTHESIA', // 국소 마취비
  LAUGHING_GAS_ANESTHESIA = 'LAUGHING_GAS_ANESTHESIA', // 웃음 마취비
  INTRAVENOUS_ANESTHESIA = 'INTRAVENOUS_ANESTHESIA', // 정맥 마취비
  GENERAL_ANESTHESIA = 'GENERAL_ANESTHESIA', // 전신 마취비
  NEEDLE = 'NEEDLE', // 바늘, 마이크로 캐뉼라 비
  MEDICATION = 'MEDICATION', // 약품비
  DOCTOR_DESIGNATION = 'DOCTOR_DESIGNATION', // 지명료
  INJECTION_PROCEDURE = 'INJECTION_PROCEDURE', // 수기료
  EXAMINATION = 'EXAMINATION', // 검사비
  ANESTHESIA = 'ANESTHESIA', // 마취비
  AFTERCARE = 'AFTERCARE', // 사후관리비
}

export enum ExtraPriceChargeType {
  INCLUDED = 'INCLUDED', // 포함
  REQUIRED = 'REQUIRED', // 필수
  OPTIONAL = 'OPTIONAL', // 임의
  NONE = 'NONE', // 없음
}

export interface ExtraPrice {
  type: ExtraPriceType
  chargeType: ExtraPriceChargeType
  amount: number | null
  name: string
}

export interface AdminServiceOfferExtraPrice extends Omit<ExtraPrice, 'name'> {}
export interface UserServiceOfferExtraPrice extends ExtraPrice {
  currency: string
}

export interface ExtraPriceListItem extends Omit<ExtraPrice, 'amount' | 'chargeType'> {}
